//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'
import ItemsSearchField from '../Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    additionalObjectTypes: {
      type: Array,
      default: null
    },
    brigadeId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    // const self = this
    return {
      defaultObjectTypes: [
        {
          key: 'serviceObject',
          name: 'Объект обслуживания',
          searchConfig: createFieldConfig(new Store({
            fullReadable: false,
            searchable: false,
            cached: true,
            proxy: {
              urlBase: '/service/delta/serviceobject/search',
              get urlParams () {
                const params = {
                  fields: 'region'
                }
                // if (self.value && self.value.region) {
                //   params.region = self.value.region.id
                // }
                return params
              },
              filterType: 'serviceObject',
              formId: 'addressField'
            }
          })),
          selectDisabled: true,
          selectionDialogLabel: 'Выбор объекта обслуживания',
          selectionDialogColumns: [
            {
              name: 'alias',
              label: 'Название',
              align: 'left',
              defaultWidth: 130,
              field: 'alias',
              sortable: true
            },
            {
              name: 'fvfComplexNumber',
              label: 'Номер комплекса',
              labelTable: 'Номер</br>комплекса',
              align: 'left',
              defaultWidth: 80,
              field: 'fvfComplexNumber',
              sortable: true
            },
            {
              name: 'typeAlias',
              label: 'Тип',
              align: 'left',
              defaultWidth: 40,
              field: 'typeAlias',
              sortable: true
            },
            {
              name: 'address',
              label: 'Адрес',
              align: 'left',
              defaultWidth: 600,
              field: 'address',
              sortable: true
            }
          ]
        },
        {
          key: 'workObject',
          name: 'Рабочий объект',
          searchConfig: createFieldConfig(new Store({
            fullReadable: true,
            searchable: false,
            cached: false,
            proxy: {
              urlBase: '/service/delta/workobjects/search',
              get urlParams () {
                const params = {
                  type: 'base,parkingPlace',
                  fields: 'region'
                }
                // if (self.value && self.value.region) {
                //   params.region = self.value.region.id
                // }
                return params
              }
            }
          })),
          selectionDialogLabel: 'Выбор рабочего объекта',
          selectionDialogColumns: [
            {
              name: 'name',
              label: 'Название',
              align: 'left',
              defaultWidth: 130,
              field: 'name',
              sortable: true
            },
            {
              name: 'address',
              label: 'Адрес',
              align: 'left',
              defaultWidth: 600,
              field: 'address',
              sortable: true
            }
          ]
        }
      ],
      objectFieldConfig: null,

      regionFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: false,
        cached: true,
        proxy: {
          urlBase: '/service/obj/search',
          urlParams: {
            type: 'Region',
            sort: 'rel',
            limit: 1000,
            params: JSON.stringify([
              {"param":"showInFilter","type":"boolean","action":"=","value":true},
              { param: 'shortName', type: 'string', action: 'any' }
            ])
          }
        }
      }))
    }
  },
  computed: {
    objectTypes: function () {
      const types = this.defaultObjectTypes

      if (this.additionalObjectTypes && this.additionalObjectTypes.length) {
        types.push(...this.additionalObjectTypes)
      }
      return types
    },
    selectedObjectType: function () {
      const typeKey = this.value && this.value.type || null
      if (typeKey) {
        return this.objectTypes.find(objectType => objectType.key === typeKey)
      }
      return null
    }
    // objectFieldConfig: function () {
    //   // const objectType = this.selectedObjectType
    //   // if (objectType && objectType.searchConfig) {
    //   //   return objectType.searchConfig
    //   // }
    //   console.log('objectFieldConfig')
    //   return createFieldConfig({ allRecordsFn: this.getObjects })
    // }
  },
  watch: {
    selectedObjectType: {
      handler: function (objectType) {
        if (objectType && objectType.searchConfig) {
          this.objectFieldConfig = objectType.searchConfig
        } else {
          this.objectFieldConfig = createFieldConfig({ allRecordsFn: this.getObjects })
        }
      },
      immediate: true
    }
  },
  methods: {
    onSelectObject: function (object) {
      if (object) {
        this.value.id = object.id
        this.value.name = object.alias || object.name
        this.value.value = object.address || object.name

        this.setRegion(object.region)
      } else {
        this.clearObject()
        this.clearRegion()
      }
    },
    onSelectType: function (type) {
      this.clearObject()
      if (!type) {
        this.clearRegion()
      }
    },
    onSelectRegion: function (region) {
      region = {
        id: region.id,
        name: region['param.shortName']
      }
      this.setRegion(region)

      if (region && !this.value.id) {
        this.value.value = region.name
      }
    },
    setRegion: function (region) {
      if (region) {
        this.value.region = {
          id: region.id,
          name: region.name
        }
      } else {
        this.value.region = null
      }
    },
    clearRegion: function () {
      this.setRegion(null)
    },
    clearObject: function () {
      this.value.id = null
      this.value.name = null
      this.value.value = null
    },
    getObjects: function () {
      const objectType = this.selectedObjectType

      if (objectType && objectType.url) {
        return axiosGet({
          url: objectType.url,
          onSuccess: (response) => response.data.result,
          onFailure: 'Ошибка получения объектов'
        })
      }
      return Promise.resolve([])
    }
  }
}

